import angular from "angular";
import { SubFilter } from "./subFilters";

export enum DateFilterType {
  date = 'date',
  datetime = 'datetime-local'
}

export class DateFilter extends SubFilter {
  public readonly type: DateFilterType;

  constructor(params: { displayName: string; queryFieldNames: string[] | string[]; type: DateFilterType }) {
    super(params)
    this.type = params.type
  }

  getGui(): angular.IAugmentedJQuery {
    const inputFactory = (index: number): string => `<div><input type="${this.type}" ng-model="${this.getQueryFieldExpression(index)}" ng-model-options="gridFilterController.defaultModelOptions" class="form-control" /></div>`
    const inputs = this.queryFieldNames.map((_fieldName: string, index: number) => inputFactory(index))
    const template = inputs.join('and')

    return angular.element(template);
  }
}
